<template>
    <div>
        <compBanner v-if="bannerList.length" :bannerList="bannerList" @clickBanner="clickBanner" />
        <!-- 搜索 -->
        <compSearch @refreshData="init"/>
        <div class="content">
            <div class="twrap flex_layout flex_y_center flex_x_spacebetween">
                <div class="flex_layout flex_xy_center"><div class="line"></div><div class="dot"></div></div>
                <div class="title">图形总览</div>
                <div class="flex_layout flex_xy_center"><div class="dot"></div><div class="line"></div></div>
            </div>

            <template>
                <div id="cwrap" class="cwrap flex_layout flex_wrap flex_x_spacebetween">
                    <template v-for="(item, index) in list" >
                        <div
                            :id="`graph_${item.id}`"
                            :key="`info_${item.id}`"
                            :data-index="index"
                            v-if="index < firstPageCount || firstPageCount === 0"
                            class="info"
                            :class="{'on':item.view}"
                            @click="clickItem(item, index)">
                            <div class="iteminfo">
                                <div class="ipimg flex_xy_center" :class="{loading:item.loading}">
                                    <div class="iphead">
                                        <img alt="blank" src="data:image/gif;base64,R0lGODlhAQABAID/AMDAwAAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" class="blankImg">
                                        <img :data-src="item.display_cover_pic ? _dealImageSuffix({value: item.display_cover_pic, width: 200}) : ''" v-lazyLoad/>
                                    </div>
                                </div>
                                <div class="title">
                                    <p>{{item.cover_pic_name | filterPicNameBefore}}</p>
                                    <p>{{item.cover_pic_name | filterPicNameAfter}}</p>
                                </div>
                            </div>
                        </div>
                        <div
                            :key="'info'+index"
                            v-if="(index%screen.linesize == screen.maxremainder) && (index < firstPageCount || firstPageCount === 0)"
                            class="line"
                            :style="{'width':cwrapWidth}">
                            <compDetail :list="list" :lineview="item.lineview" :cwrapWidth="cwrapWidth" :detail="detail"/>
                        </div>
                    </template>
                    <template v-if="hasI">
                        <template v-for="(item, index) in virtualIcount">
                            <i></i>
                        </template>
                        <!-- 详情信息 -->
                        <div class="line end" :style="{'width':cwrapWidth}">
                            <compDetail :list="list" :lineview="ilineview" :cwrapWidth="cwrapWidth" :detail="detail"/>
                        </div>
                    </template>
                </div>
                <div v-show="viewMore" class="more">
                    <div v-show="!flagmore" @click="clickMore(true)" class="flex_xy_center"><span>查看更多</span><span><svg viewBox="64 64 896 896" focusable="false" style="position: absolute;left: 0;top: 0" fill="currentColor"><path d="M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z"></path></svg></span></div>
                    <div v-show="flagmore" @click="clickMore(false)"><span>收起</span></div>
                </div>
            </template>
            <div v-if="isEmpty" class="emptywrap">
                <div class="eimg"><img src="../img/empty.png" alt=""/></div>
                <p>暂无推荐的图形信息，您可以提交你的需求我们会进行人工推荐并联系您</p>
            </div>
        </div>
    </div>
</template>

<script>
import compSearch from './compSearch';
import compDetail from './compDetail';
import compBanner from './compBanner';
import { toast } from '@kkmh/utils';
const s_screen = { // 1184px以下屏幕
    moresize: 20, // 默认显示数量
    maxsize: 50, // 数量50不显示更多按钮
    linesize: 4, // 每行显示数量
    maxremainder: 3, // 最大余数
};
const b_screen = { // 1184px以上屏幕
    moresize: 30, // 默认显示数量
    maxsize: 50, // 数量50不显示更多按钮
    linesize: 6, // 每行显示数量
    maxremainder: 5, // 最大余数
};
export default {
    name: 'content',
    components: {
        compSearch,
        compDetail,
        compBanner
    },
    data () {
        return {
            list: [],
            detail: {},
            flagmore: false,
            cwrapWidth: '',
            ilineview: false,
            screen: {},
            bannerList: []
        };
    },
    computed: {
        hasI () {
            if ((this.viewMore && this.flagmore && this.virtualIcount.length) ||
                (!this.viewMore && this.virtualIcount.length)) {
                return true;
            } else {
                return false;
            }
        },
        virtualIcount () {
            const { linesize } = this.screen;
            const len = this.list && this.list.length;
            if (linesize && len && (len % linesize !== 0)) {
                return new Array(linesize - (len % linesize));
            } else {
                return [];
            }
        },
        viewMore () {
            const len = this.list && this.list.length;
            return (len > this.screen.maxsize) || false;
        },
        firstPageCount () {
            const len = this.list && this.list.length;
            if (!this.viewMore) {
                return 0;
            }
            if (this.flagmore) {
                return 0;
            }
            return this.screen.moresize;
        },
        isEmpty () {
            const len = this.list && this.list.length;
            if (len > 0) return false;
            return true;
        },
    },
    created () {
        this.init();
        this.getBannerList();
    },
    mounted () {
        this.$nextTick(() => {
            let bw = this.getDivWidth('bw'); // body宽度
            let w = this.getDivWidth('cwrap'); // list容器宽度
            if (w > 1184 || w > bw) w = '';
            this.cwrapWidth = w ? w+'px' : '';
            this.screen = bw < 1184 ? s_screen : b_screen;
        });
    },
    filters: {
        filterPicNameBefore (name) {
            return name.substring(0, 7);
        },
        filterPicNameAfter (name) {
            return name.substring(7, 14);
        }
    },
    methods: {
        init () {
            let {data = []} = window.getListData || {};
            this.list = [];
            this.$nextTick(() => {
                this.list = data;
            });
        },

        async getBannerList () {
            const params = {
                url: '/v3/ad/activity/ip_pic/list',
                data: {
                    carousel_status: 1
                }
            };
            const {data, code} = await request(params);
            if (code === 200) {
                this.bannerList = data || [];
            }

        },
        clickBanner ({ bannerIndex, elId }) {
            let curDom = document.getElementById(elId);
            if (!curDom) {
                this.clickMore(true);
                this.$nextTick(() => {
                    curDom = document.getElementById(elId);
                    curDom ? this.scroll2GraphDetail(curDom) : this.copyBannerGraph2List(this.bannerList[bannerIndex], elId);
                });
            } else {
                this.scroll2GraphDetail(curDom);
            }

        },

        scroll2GraphDetail (dom) {
            const index = +dom.getAttribute('data-index');
            const height = dom.offsetTop;
            window.scrollTo({
                top: height,
                behavior: 'smooth'
            });
            this.clickItem(this.list[index], index);
        },

        copyBannerGraph2List (banner, elId) {
            this.list.unshift(banner);
            this.$nextTick(() => {
                const curDom = document.getElementById(elId);
                curDom && this.scroll2GraphDetail(curDom);
            });
        },

        async clickItem (targetInfo, targetIndex) {
            const {linesize, maxremainder} = this.screen;
            const linenum = Math.ceil((targetIndex+1) / linesize);
            const targetLineIndex = (linenum-1) * linesize + maxremainder;

            // 重新点击关闭详情
            if (targetInfo.view) {
                this.$set(targetInfo, 'view', false);

                if (this.list[targetLineIndex]) {
                    this.$set(this.list[targetLineIndex], 'lineview', false);
                } else {
                    this.ilineview = false;
                }
                return;
            }

            await this.getDetail(targetInfo, targetIndex);
            this.list.forEach(item => {
                this.$set(item, 'view', false);
                this.$set(item, 'lineview', false);
            });
            this.ilineview = false;

            this.$nextTick(() => {
                this.$set(targetInfo, 'view', true);
                if (this.list[targetLineIndex]) {
                    this.$set(this.list[targetLineIndex], 'lineview', true);
                } else {
                    this.ilineview = true;
                }
            });

            // console.log(targetLineIndex);
        },
        getDetail (info, targetIndex) {
            return new Promise(resolve => {
                this.$set(this.list[targetIndex], 'loading', true);
                request({
                    url: '/v3/ad/activity/ip_pic/get',
                    data: {
                        id: info.id,
                    }
                }).then((res) => {
                    let {code, data={}, message} = res;
                    this.detail = {
                        ...data.detail,
                        recommand: data.recommand,
                    };

                    // setTimeout(() => {
                        this.$set(this.list[targetIndex], 'loading', false);
                        resolve();
                    // },500)

                }).catch((error) => {
                    toast(`详情页获取失败：${error}`);
                    this.$set(this.list[targetIndex], 'loading', false);
                    resolve();
                });
            });
        },
        clickMore (flag) {
            this.flagmore = flag;
        },
        getDivWidth (id) {
            const el = document.getElementById(id);
            let width = 0;
            if (el) {
                width = el.style.width || el.clientWidth || el.offsetWidth || el.scrollWidth;
            }
            // console.log('width', width);
            return width;
        },
        // getDivHeight(id){
        //     const el = document.getElementById(id);
        //     let height = 0;
        //     if (el) {
        //         height = el.style.height || el.clientHeight || el.offsetHeight || el.scrollHeight;
        //     }
        //     // console.log('height', height);
        //     return height;
        // },
        // getOffsetX(id) {
        //     let el = document.getElementById(id);
        //     el = el.getBoundingClientRect();
        //     let x = el.left + window.scrollX;
        //     // console.log(id,'X', x);
        //     return x;
        // }
    }
};
</script>

<style lang='scss' scoped>
@import "@/css/common.scss";
.content{
    margin:vws(66px) auto;
    width:vws(1184px);
    overflow:hidden;
    .twrap{
        background:white;
        width:vws(286px);
        margin:0 auto;
        .title{
            color: #1E1E1E;
            font-size:vws(30px);
            font-weight:bold;
        }
        .line{
            width:vws(54px);
            height:1px;
            background:black;
        }
        .dot{
            width:vws(5px);
            height:vws(5px);
            border-radius:50%;
            background: #1E1E1E;
        }
    }
    .cwrap{
        padding-top: vws(40px);
        //margin-bottom: vws(50px);
        width:vws(1224px);
        //justify-content: space-between;
        //display: grid;
        //grid-template-columns: repeat(auto-fill, vws(146px));
        //grid-gap: vws(40px) vws(60px);
        .line{
            width:vws(1224px);
            //border:1px solid red;
        }
        i{
            width: vws(146px);
            margin-right:vws(40px);
        }
        .info{
            margin-right:vws(40px);
            .iteminfo{
                position:relative;
                .ipimg{
                    width: vws(146px);
                    height: vws(146px);
                    border: vws(2px) solid #FFE120;
                    border-radius: vws(24px);
                    .iphead{
                        position:relative;
                        font-size:0;
                        width: vws(130px);
                        height: vws(130px);
                        background: #E5E5E5;
                        border-radius: vws(24px);
                        overflow:hidden;
                    }
                }
                .title{
                    text-align: center;
                    line-height: vws(28px);
                    padding: vws(16px) 0 vws(32px) 0;
                    width: vws(146px);
                    font-size: vws(24px);
                    font-weight: 500;
                    color: #000000;
                    //overflow: hidden;
                    //white-space: nowrap;
                    //text-overflow: ellipsis;
                    transform: scale(0.8);
                    transform-origin: left center;
                    p{
                        white-space: nowrap;
                        text-align: center;
                        width: vws(180px);
                    }
                }
            }
        }
        .on{
            position:relative;
        }
        .on:after{
            content: "";
            display: inline-block;
            width: 0;
            height: 0;
            border: vws(18px) solid transparent;
            border-bottom: vws(28px) solid #FFE120;
            position: absolute;
            left: 50%;
            bottom:vws(-5px);
            transform: translateX(-50%);
        }
        .loading{
            position:relative;
        }
        .loading:before{
            content: "";
            background:rgba(0, 0, 0, .3);
            display: inline-block;
            width: 100%;
            height: 100%;
            position: absolute;
            top:0;
            left: 0;
        }
        .loading:after{
            content: "";
            display: inline-block;
            width: vws(50px);
            height: vws(50px);
            background-image: url("data:image/png;base64,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");
            background-size: contain;
            position: absolute;
            animation: loading__rotate 1s steps(12) infinite;
        }
    }
    .more{
        font-size: vws(18px);
        color: #000000;
        text-align: center;
        font-family: Microsoft YaHei;
        span:last-child{
            position:relative;
            width:vws(15px);
            height:vws(15px);
        }
    }
    .emptywrap{
        .eimg{
            margin:vws(50px) auto 0;
            width:vws(343px);
            height:vws(275px);
        }
        p{
            font-size: vws(24px);
            font-weight: 400;
            color: #1E1E1E;
            padding-top:vws(24px);
            text-align:center;
            transform: scale(0.835);
            transform-origin: center center;
        }
    }
}
@media (max-width:750px) {
    .content{
        width:100%;
        padding: 0 0.2rem;
        .cwrap{
            width:100%;
            i{
                margin-right:0;
            }
            .info{
                margin-right:0;
            }
        }
    }
}
</style>


